var _defs, _style, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "template") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 38,
    height: 36,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAkCAMAAADSK7iXAAAAAXNSR0IB2cksfwAAAGZQTFRFAAAAICAoICAkICAkISAlISAlICAkISEhICAgICAlICAlICAlIiAmISAlICAjICAmICAlICAjICAkICAkICAjISEmICAkICAkICAlICAkISAkISAlISAmIiAkISAlICAlICAgISAkWMf8zwAAACJ0Uk5TACB/z+//jx8Qn29gr9+fX99QQL9fL08/z6/vz9+vvzAgv+MecDYAAAFwSURBVHicjZTrloIwDITT0tDbFiqlVtRV9/1fckN1hZUizuEP5EumTDgAjGK8EiiqWsIbqRqFNpZ/OWzWQeYEVyAlEa3zaxyjkuIOET1XbJXTQjJy23U7jV4yEcrDsAfnI8A+D1YtpuIwDy2SUcJu7OEgmhJ2GMbrgYE+Qn0sYdSPJmOBbC1Kg2VM0ekovNO5zphFVcCoKOrnHTnyoum3o9pfP3MNhEsJS5iYqO6cGihDnOk4+R+8isL3ClSqcob2KY3TSiI2wC65+RJB51wesjOM0qU9sh23V2Ahv3URg+hw6KOMbUA/mzViSc7TaU93U/4/Mjs+rObz1VlfF7FatON3M8wKZ74My+I+RTBYb2GkGvhsfWWsuxnsVf423mEyF5BvYEly7NkszNWzaTqb3MBsd4V++033iVYzwBY2rsbAJtbdXlazGsgL5oMBY4CHSb6AVdpA24PRk34K2Iemn2HBtwtVftHJTriQeP6cfgEQoBWDgeaHswAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n\t\ttspan { white-space:pre } \r\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.292d4d88eb8d1ddc91da3adeef545be4.svg";
export { ForwardRef as ReactComponent };